module.exports = __webpack_public_path__ + "static/media/bard.2a1bf89c.png";